import { convertOptionsToId } from "./convertOptionsToId.js";
const observerMap = /* @__PURE__ */ new Map();
function createObserver(options) {
  const id = convertOptionsToId(options);
  const instance = observerMap.get(id);
  if (instance) {
    return instance;
  }
  const elements = /* @__PURE__ */ new Map();
  let thresholds = Array.isArray(options.threshold) ? options.threshold : [options.threshold ?? 0];
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const inView = entry.isIntersecting && thresholds.some((threshold) => entry.intersectionRatio >= threshold);
      if (options.trackVisibility && typeof entry.isVisible === "undefined") {
        entry.isVisible = inView;
      }
      elements.get(entry.target)?.forEach((onChange) => {
        onChange(inView, entry);
      });
    });
  }, options);
  thresholds = observer.thresholds ?? thresholds;
  function removeFromCache() {
    observerMap.delete(id);
  }
  observerMap.set(id, { id, observer, elements, removeFromCache });
  return observerMap.get(id);
}
export {
  createObserver
};
//# sourceMappingURL=createObserver.js.map
